// From https://stackoverflow.com/questions/23674175/in-javascript-how-can-i-test-if-any-ajax-call-is-running-in-the-background-at-a#answer-23674587

export const getAJAXRequests = (function() {
  const oldSend = XMLHttpRequest.prototype.send
  const currentRequests = []

  XMLHttpRequest.prototype.send = function() {
    currentRequests.push(this) // add this request to the stack
    oldSend.apply(this, arguments) // run the original function

    // add an event listener to remove the object from the array
    // when the request is complete
    this.addEventListener('readystatechange', function() {
      let idx = null

      if (this.readyState === XMLHttpRequest.DONE) {
        idx = currentRequests.indexOf(this)
        if (idx > -1) {
          currentRequests.splice(idx, 1)
        }
      }
    }, false)
  }

  return function() {
    return currentRequests
  }
}())
